export type TradingMode =
  | 'home'
  | 'swap'
  | 'futures'
  | 'cfd'
  | 'exchanges'
  | 'exchange_arbitrage'
  | 'prop_firm'
  | 'robot'
  | 'events'
  | 'wallet'
  | 'profile'
  | 'staking'
  | 'wheel'
  | 'payment_sandbox';

export const DASHBOARD_PATHS: Record<TradingMode, string> = {
  home: '/',
  swap: '/swap',
  futures: '/futures',
  cfd: '/cfd',
  exchanges: '/exchanges',
  exchange_arbitrage: '/exchange-arbitrage',
  prop_firm: '/prop-firm',
  robot: '/robot',
  events: '/events',
  wallet: '/wallet',
  profile: '/profile',
  staking: '/staking',
  wheel: '/wheel',
  payment_sandbox: '/payment-sandbox',
};

const MODE_BY_PATH = new Map(
  Object.entries(DASHBOARD_PATHS).map(([mode, path]) => [path, mode as TradingMode])
);

export const getTradingModeFromPath = (pathname: string): TradingMode => {
  const normalizedPath = pathname !== '/' ? pathname.replace(/\/+$/, '') : pathname;
  return MODE_BY_PATH.get(normalizedPath) ?? 'home';
};
